import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Span = styled.span`
  cursor: pointer;
  padding: 0.3rem;
  color: ${props => props.theme.colors.appPrimaryDark};
  display: inline-block;
  position: absolute;
  right: 0.3rem;
  top: 0rem;
  margin-top: ${props => props.marginTop};
`;

const ClearInput = ({ clearButton, onMouseDown, value, marginTop }) => {
  if (!clearButton || !value) {
    return null;
  }
  return (
    <Span className="icon" onMouseDown={onMouseDown} marginTop={marginTop}>
      clear
    </Span>
  );
};
ClearInput.propTypes = {
  clearButton: PropTypes.bool,
  onMouseDown: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
ClearInput.defaultProps = {
  clearButton: false,
  onMouseDown: () => {},
  value: '',
  marginTop: undefined,
};
export default ClearInput;
